export class BillingCode {
    constructor(public id?: number, public code?: string, public description?: string, public price?: number, public deleted?: boolean) {}
}
